("use strict");
var routes = window.routes = window.routes || {
  cart_add_url: '/cart/add.js',
  cart_change_url: '/cart/change.js',
  cart_update_url: '/cart/update.js',
  cart_url: '/cart',
  search_url: '/search',
  predictive_search_url: '/search/suggest'
};
if (routes.cart_add_url && !/\.js(\?|$)/.test(routes.cart_add_url)) {
  routes.cart_add_url += '.js';
}

function fetchConfig(type = "json") {
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/${type}`,
      },
    };
  }

  class QuickBuy extends HTMLElement {
    constructor() {
      super();
      this.miniCart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      this.buttonAddToCart = this.querySelector(".bls__js-addtocart");
      QuickBuy.ensureGridDelegation();
      this.productVariantId = this.dataset.productVariantId;
    }

    static ensureGridDelegation() {
      if (QuickBuy._gridAtcDeleg) return;
      QuickBuy._gridAtcDeleg = true;
      document.body.addEventListener(
        "click",
        (ev) => {
          const btn = ev.target.closest && ev.target.closest(".bls__js-addtocart");
          if (!btn || !btn.closest(".bls__product-item")) return;
          const host = btn.closest("quick-buy");
          if (!host) return;
          ev.preventDefault();
          host.actionAddToCart(ev);
        },
        false
      );
    }

    updateMasterId(options, variantData) {
      var result = variantData.find((variant) => {
        return !variant.options
          .map((option, index) => {
            return options[index] === option;
          })
          .includes(false);
      });
      return result;
    }

    miniCartRoot() {
      return (
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer") ||
        this.miniCart
      );
    }

    actionAddToCart(e) {
      e.preventDefault();
      if (!this.buttonAddToCart) return;
      this.buttonAddToCart.classList.add("btn-loading");
      const productTarget = this.buttonAddToCart.closest(".bls__product-item");
      if (!productTarget) {
        this.buttonAddToCart.classList.remove("btn-loading");
        return;
      }
      const p = productTarget.querySelector(".bls__product-addtocart-js");
      if (!p || !p.dataset) {
        this.buttonAddToCart.classList.remove("btn-loading");
        return;
      }
      let prodVariantId = p.dataset.productVariantId;
      const exist_load = this.buttonAddToCart.querySelectorAll("span.loader-icon");
      if (exist_load.length === 0) {
        const exist_loading = this.buttonAddToCart.querySelectorAll("div.loader-icon");
        if (exist_loading.length === 0) {
          const spanLoading = document.createElement("div");
          spanLoading.classList.add("loader-icon");
          this.buttonAddToCart.appendChild(spanLoading);
        }
      }
      const gridHandle =
        productTarget.dataset && productTarget.dataset.productHandle;
      if (
        gridHandle &&
        window.BlsSubActionProduct &&
        typeof window.BlsSubActionProduct.handleFetchDataQuickView ===
          "function"
      ) {
        window.BlsSubActionProduct.handleFetchDataQuickView(
          this.buttonAddToCart,
          gridHandle
        );
        return;
      }
      var qty = 1;
      const miniCartEl = this.miniCartRoot();
      const sectionMiniCart =
        miniCartEl && typeof miniCartEl.getSectionsToRender === "function"
          ? miniCartEl.getSectionsToRender().map((section) => section.id)
          : [];
      if (productTarget.querySelector(".productinfo")) {
        const variantData = JSON.parse(
          productTarget.querySelector(".productinfo").textContent
        );
        let options = Array.from(
          productTarget.querySelectorAll(".bls__option-swatch-js.active"),
          (select) => select.getAttribute("data-value")
        );
        if (options.length > 0) {
          const currentVariant = this.updateMasterId(options, variantData);
          if (!currentVariant) {
            this.selectOption(productTarget, this.buttonAddToCart);
            return;
          }
          prodVariantId = String(currentVariant.id);
        }
      }
      this.fetchAddCart(prodVariantId, qty, sectionMiniCart, this.buttonAddToCart);
    }

    selectOption(productTarget, e) {
      const productHandle = productTarget.dataset.productHandle;
      e.classList.remove("btn-loading");
      e.querySelectorAll(".loader-icon").forEach((el) => {
        el.remove();
      });
      if (productHandle) {
        const root =
          (window.Shopify &&
            window.Shopify.routes &&
            window.Shopify.routes.root) ||
          "/";
        window.location.href =
          (root.endsWith("/") ? root : root + "/") + "products/" + productHandle;
      }
    }

    fetchAddCart(variantId, quantity, properties, e) {
      fetch(`${routes?.cart_add_url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: Number(quantity),
          sections: properties,
        }),
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          fetch("/cart.json")
            .then((res) => res.json())
            .then((cart) => {
              if (cart.item_count != undefined) {
                document.querySelectorAll(".cart-count").forEach((el) => {
                  if (el.classList.contains('cart-count-drawer')) {
                    el.innerHTML = `(${cart.item_count})`;
                    }else{
                    el.innerHTML = cart.item_count;
                    }
                });
                if (document.querySelector("header-total-price")) {
                  document
                    .querySelector("header-total-price")
                    .updateTotal(cart);
                }
              }
            })
            .catch((error) => {
              throw error;
            });
          const parsedState = JSON.parse(state);
          const miniCartEl = this.miniCartRoot();
          if (!parsedState.errors) {
            if (
              miniCartEl &&
              typeof miniCartEl.getSectionsToRender === "function" &&
              parsedState.sections
            ) {
              miniCartEl.getSectionsToRender().forEach((section) => {
                const secHtml = parsedState.sections[section.id];
                if (!secHtml) return;
                const elementToReplace = document.getElementById(section.id);
                const html = new DOMParser().parseFromString(
                  secHtml,
                  "text/html"
                );
                if (elementToReplace) {
                  const miniForm = html.querySelector("#form-mini-cart");
                  if (miniForm) {
                    elementToReplace.innerHTML = miniForm.innerHTML;
                  }
                }
                const countdown = miniCartEl.querySelector(".cart-countdown-time");
                const html_countdown = html.querySelector(".cart-countdown-time");
                if (countdown && html_countdown) {
                  countdown.innerHTML = html_countdown.innerHTML;
                  miniCartEl.countdownTimer();
                }
                const cartUpsell = miniCartEl.querySelector('.bls-recommendations-beside');
                const html_cartUpsell = html.querySelector('.bls-recommendations-beside');
                const cartUpsellMobile = miniCartEl.querySelector('.cart-recomment-beside-mobile');
                const html_cartUpselSelected = html.querySelector('.bls-recommendations-beside-selected');
                var counteSelect;
                if (cartUpsell && html_cartUpsell) {
                  if (html_cartUpselSelected) {
                    counteSelect = Array.from(html_cartUpselSelected.getElementsByClassName('bls-cart-upsell-item'));
                    if (counteSelect.length == 0) {
                      cartUpsell.classList.remove('is-opend');
                      if (cartUpsellMobile) cartUpsellMobile.classList.add('d-none');
                    }
                  }
                  if (!counteSelect || counteSelect.length != 0) {
                    setTimeout(() => {
                      cartUpsell.classList.add("is-opend");
                    }, 1500);
                  }
                  cartUpsell.innerHTML = html_cartUpsell.innerHTML
                }
              });
            }
            if (miniCartEl && typeof miniCartEl.cartAction === "function") {
              miniCartEl.cartAction();
            }
            if (miniCartEl && miniCartEl.classList.contains("is-empty"))
              miniCartEl.classList.remove("is-empty");
            if (miniCartEl && typeof miniCartEl.open === "function") {
              miniCartEl.open();
            }
          }else{
            const content = document.querySelector(".form-infor .add-cart-error");
          if (!content) return;
          var error_message = EasyDialogBox.create(
            "add_cart_error",
            "dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading",
            "",
            content.innerHTML
          );
          error_message.onClose = error_message.destroy;
          error_message.show();
          }

        })
        .catch((e) => {
          throw e;
        })
        .finally(() => {
          e.classList.remove("btn-loading");
          e.querySelectorAll(".loader-icon").forEach((el) => {
            el.remove();
          });
          Shopify.termsConditionsAction();
          BlsLazyloadImg.init();
          BlsSettingsSwiper.init();
        });
    }

    getSectionsToRender() {
      return [
        {
          id: "form-mini-cart",
        },
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents',
        }
      ];
    }
  }

  customElements.define("quick-buy", QuickBuy);

  if (!customElements.get("product-form")) {
    customElements.define(
      "product-form",
      class ProductForm extends HTMLElement {
        constructor() {
          super();
          this.form = this.querySelector("form");
          this.form.querySelector("[name=id]").disabled = false;
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
          this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");
          this.submitButton = this.querySelector('[type="submit"]');
          if (document.querySelector("cart-drawer"))
            this.submitButton.setAttribute("aria-haspopup", "dialog");
          this.hideErrors = this.dataset.hideErrors === "true";
        }
  
        onSubmitHandler(evt) {
          evt.preventDefault();
  
          this.handleErrorMessage();
  
          const config = fetchConfig("json");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];
  
          const formData = new FormData(this.form);
          const bpdi = this.form.closest(".bls__product-details-infor");

          const formIdStr = (this.form && typeof this.form.getAttribute === "function" && this.form.getAttribute("id")) || "";
          const formIdMatch =
            formIdStr && formIdStr.match(/(?:product-form|sticky-addcart-form)-(.+)/);
          const dualSectionId = formIdMatch ? formIdMatch[1] : null;
          const mainProductFormEl = dualSectionId
            ? document.getElementById("product-form-" + dualSectionId)
            : null;
          const dualSizeScope = mainProductFormEl || this.form;

          if (
            dualSectionId &&
            window.LVD &&
            typeof window.LVD.syncDualSizeSection === "function"
          ) {
            try {
              window.LVD.syncDualSizeSection(dualSectionId);
            } catch (e) {}
          }

          let mensSizeInput = document.querySelector(
            'input[name="properties[Men\'s Size]"]:checked'
          );
          let womensSizeInput = document.querySelector(
            'input[name="properties[Women\'s Size]"]:checked'
          );
          if (formIdStr && formIdStr.indexOf("sticky-addcart-form-") === 0 && dualSectionId) {
            const stickyM = document.getElementById("sticky-mens-size-" + dualSectionId);
            const stickyW = document.getElementById("sticky-womens-size-" + dualSectionId);
            if (stickyM && stickyM.value) mensSizeInput = stickyM;
            else mensSizeInput = null;
            if (stickyW && stickyW.value) womensSizeInput = stickyW;
            else womensSizeInput = null;
          }
          const mensSize = mensSizeInput ? mensSizeInput.value : null;
          const womensSize = womensSizeInput ? womensSizeInput.value : null;

          const hasMensOptions = !!document.querySelector('input[name="properties[Men\'s Size]"]');
          const hasWomensOptions = !!document.querySelector('input[name="properties[Women\'s Size]"]');

          if (hasMensOptions && hasWomensOptions) {
            if (!mensSize || !womensSize) {
              const txt = "Please select both Men's and Women's sizes before adding to cart.";
              if (typeof EasyDialogBox !== 'undefined') {
                // Destroy any previous instance to avoid duplicates
                var prev = EasyDialogBox.getById('size_select_error_0');
                if (prev) prev.destroy();
                var dlg = EasyDialogBox.create(
                  'size_select_error',
                  'dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading',
                  '',
                  '<div style="padding:2.5rem 2rem; text-align:center;"><div style="font-size:2rem; font-weight:700; margin-bottom:1.2rem; color:var(--heading-color, #222);">Size Selection Required</div><p style="font-size:1.4rem; color:#555; line-height:1.6;">Please select both a <strong>Men\'s</strong> and a <strong>Women\'s</strong> size before adding to cart.</p><p style="font-size:1.2rem; color:#999; margin-top:1rem;">Both sizes must be selected to continue.</p></div>'
                );
                dlg.onClose = dlg.destroy;
                dlg.show();
              } else {
                alert(txt);
              }
              return;
            }
          }

          if (bpdi) {
            bpdi.querySelectorAll("product-property").forEach((property) => {
              const input = property.querySelector("input");
              if (input.classList.contains("file") && input.files[0]) {
                formData.append(input.name, input.files[0]);
              } else if (input.classList.contains("text") && input.value) {
                formData.append(input.name, input.value);
              }
            });
          }
          
          // Add size properties to form data
          if (mensSize) {
            formData.append('properties[Men\'s Size]', mensSize);
          }
          if (womensSize) {
            formData.append('properties[Women\'s Size]', womensSize);
          }
          
          this.submitButton.setAttribute("disabled", true);
          this.submitButton.classList.add("btn-loading");
          
          // If both sizes are selected, we need to add both variants to cart
          if (mensSize && womensSize) {
            // Try multiple selectors to find the variants script (FIXED: Issue #2)
            let productVariantsScript = null;
            
            // Strategy 1: Look in form's parent containers
            const formParent = this.form.closest('.bls__product-details-infor') || 
                              this.form.closest('.bls__template-main-product') ||
                              this.form.closest('[data-section]');
            if (formParent) {
              productVariantsScript = formParent.querySelector('script[data-product-variants]');
            }
            
            // Strategy 2: Look by section ID from form ID
            if (!productVariantsScript && formIdStr) {
              const formIdMatch = formIdStr.match(
                /(?:product-form|sticky-addcart-form)-(.+)/
              );
              if (formIdMatch) {
                productVariantsScript = document.querySelector(`script[data-product-variants][data-section="${formIdMatch[1]}"]`);
              }
            }
            
            // Strategy 3: Look anywhere in document
            if (!productVariantsScript) {
              productVariantsScript = document.querySelector('script[data-product-variants]');
            }
            
            // Strategy 4: Look for script near the form (next sibling or parent's next sibling)
            if (!productVariantsScript) {
              const formSibling = this.form.nextElementSibling;
              if (formSibling && formSibling.tagName === 'SCRIPT' && formSibling.hasAttribute('data-product-variants')) {
                productVariantsScript = formSibling;
              } else {
                const formParent = this.form.parentElement;
                if (formParent) {
                  const parentSibling = formParent.nextElementSibling;
                  if (parentSibling && parentSibling.tagName === 'SCRIPT' && parentSibling.hasAttribute('data-product-variants')) {
                    productVariantsScript = parentSibling;
                  }
                }
              }
            }
            
            // Strategy 5: Look by form ID attribute
            if (!productVariantsScript && this.form.id) {
              const scripts = document.querySelectorAll('script[data-product-variants]');
              for (const script of scripts) {
                if (script.getAttribute('data-form-id') === this.form.id) {
                  productVariantsScript = script;
                  break;
                }
              }
            }
            
            if (productVariantsScript && productVariantsScript.textContent && productVariantsScript.textContent.trim()) {
              try {
                this.addDualSizeToCart(mensSize, womensSize, formData, config, productVariantsScript);
                return;
              } catch (error) {
                console.error('Error in addDualSizeToCart:', error);
                // Fall through to normal add to cart
              }
            } else {
              console.warn('Product variants script not found. Available scripts:', 
                Array.from(document.querySelectorAll('script[data-product-variants]')).map(s => ({
                  found: !!s,
                  hasContent: s ? !!s.textContent : false,
                  parent: s ? s.parentElement?.className : null
                }))
              );
              // Fall through to normal add to cart
            }
          }
          
          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
          fetch(`${routes?.cart_add_url}`, config)
            .then((response) => {
              return response.text();
            })
            .then((state) => {
              this.submitButton.setAttribute("disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              fetch("/cart.json")
                .then((res) => res.json())
                .then((cart) => {
                  if (cart.item_count != undefined) {
                    document.querySelectorAll(".cart-count").forEach((el) => {
                      if (el.classList.contains('cart-count-drawer')) {
                        el.innerHTML = `(${cart.item_count})`;
                        }else{
                        el.innerHTML = cart.item_count;
                        }
                    });
                    if (document.querySelector("header-total-price")) {
                      document
                        .querySelector("header-total-price")
                        .updateTotal(cart);
                    }
                  }
                })
                .catch((error) => {
                  throw error;
                });
              const parsedState = JSON.parse(state);
              const pswp = document.querySelector('.pswp__button--bls--close');
              if (!parsedState.errors) {
                this.cart.getSectionsToRender().forEach((section) => {
                  const elementToReplace = document.getElementById(section.id);
                  const html = new DOMParser().parseFromString(
                    parsedState.sections[section.id],
                    "text/html"
                  );
                  elementToReplace.innerHTML =
                    html.querySelector("#form-mini-cart").innerHTML;
  
                  const countdown = this.cart.querySelector(
                    ".cart-countdown-time"
                  );
                  const html_countdown = html.querySelector(
                    ".cart-countdown-time"
                  );
                  if (countdown && html_countdown) {
                    countdown.innerHTML = html_countdown.innerHTML;
                    this.cart.countdownTimer();
                  }
                  const cartUpsell = this.cart.querySelector('.bls-recommendations-beside');
                  const html_cartUpsell = html.querySelector('.bls-recommendations-beside');
                  const html_cartUpselSelected = html.querySelector('.bls-recommendations-beside-selected');
                  var counteSelect;
                  if (cartUpsell && html_cartUpsell) {
                    if (html_cartUpselSelected) {
                      counteSelect = Array.from(html_cartUpselSelected.getElementsByClassName('bls-cart-upsell-item'));
                      if (counteSelect.length == 0) {
                        cartUpsell.classList.remove('is-opend')
                      }
                    }
                    if (!counteSelect || counteSelect.length != 0) {
                      setTimeout(() => {
                        cartUpsell.classList.add("is-opend");
                      }, 1500);
                    }
                    cartUpsell.innerHTML = html_cartUpsell.innerHTML
                  }
                });
                const quantity = parsedState.quantity;
                if (document.querySelector(".quantity__label") && quantity > 0) {
                  document
                    .querySelector(".quantity-cart").innerHTML = quantity;
                  document.querySelector(".quantity__label").classList.remove("hidden");
                }
                if (this.closest(".dlg")) {
                  document.querySelector(".dlg-close-x").click();
                }
                this.cart.cartAction();
                this.cart.open();
                if (pswp) {
                  pswp.click();
                }
              } else {
                const content = document.querySelector(
                  ".form-infor .add-cart-error"
                );
                const contentGiftCard = document.querySelector(
                  ".form-infor .add-gift-card-error"
                );
                const contentGiftCardDay = document.querySelector(
                  ".form-infor .add-gift-card-day-error"
                );
                if (!content || !contentGiftCard || !contentGiftCardDay) return;
                let quickview = EasyDialogBox.getById("qvdialog_0");
                let add_cart_view = EasyDialogBox.getById(
                  "dlg-product-quickview_0"
                );
                if (pswp) {
                  pswp.click();
                }
                if (quickview) {
                  quickview.onClose = quickview.destroy;
                  quickview.hide();
                }
                if (add_cart_view) {
                  add_cart_view.onClose = add_cart_view.destroy;
                }
                if (parsedState.description?.email) {
                  var error_message = EasyDialogBox.create(
                    "add_gift_card_error",
                    "dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading",
                    "",
                    contentGiftCard.innerHTML
                  );
                  error_message.onClose = error_message.destroy;
                  error_message.show();
                } else if (parsedState.description?.send_on) {
                  var error_message = EasyDialogBox.create(
                    "add_gift_card_day_error",
                    "dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading",
                    "",
                    contentGiftCardDay.innerHTML
                  );
                  error_message.onClose = error_message.destroy;
                  error_message.show();
                } else if (parsedState.errors) {
                  var error_message = EasyDialogBox.create(
                    "add_cart_error",
                    "dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading",
                    "",
                    content.innerHTML
                  );
                  error_message.onClose = error_message.destroy;
                  error_message.show();
                }
              }
            })
            .catch((e) => {
              throw e;
            })
            .finally(() => {
              this.submitButton.classList.remove("btn-loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error) this.submitButton.removeAttribute("disabled");
              this.submitButton.querySelector("span").classList.remove("hidden");
              Shopify.termsConditionsAction();
              BlsLazyloadImg.init();
              BlsSettingsSwiper.init();
            });
        }
        
        async addDualSizeToCart(mensSize, womensSize, originalFormData, config, variantsScript) {
          try {
            const baseQuantity = parseInt(originalFormData.get('quantity')) || 1;
            const sections = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];
            const sectionsUrl = window.location.pathname;
            
            // Get product variants data
            if (!variantsScript || !variantsScript.textContent) {
              console.error('Variants script not found or empty');
              throw new Error('Variants script not found');
            }
            
            let productVariants;
            try {
              productVariants = JSON.parse(variantsScript.textContent);
            } catch (parseError) {
              console.error('Error parsing variants JSON:', parseError);
              throw new Error('Invalid variants data format');
            }
            
            if (!Array.isArray(productVariants) || productVariants.length === 0) {
              console.error('No variants found in product data');
              throw new Error('No variants found');
            }
            
            const mensSizeLower = mensSize.toLowerCase().trim();
            const womensSizeLower = womensSize.toLowerCase().trim();

            let finalMensVariant = null;
            let finalWomensVariant = null;
            const dSectionId = variantsScript.getAttribute("data-section");
            if (dSectionId) {
              const mf = document.getElementById("product-form-" + dSectionId);
              const mensRadio = mf?.querySelector(
                'input[name="properties[Men\'s Size]"]:checked'
              );
              const womensRadio = mf?.querySelector(
                'input[name="properties[Women\'s Size]"]:checked'
              );
              const mid = mensRadio?.getAttribute("data-variant-id");
              const wid = womensRadio?.getAttribute("data-variant-id");
              if (mid && wid) {
                finalMensVariant =
                  productVariants.find((v) => String(v.id) === String(mid)) || null;
                finalWomensVariant =
                  productVariants.find((v) => String(v.id) === String(wid)) || null;
              }
            }

            // Size mapping for flexible matching (handles "XS" vs "Extra Small", "2XL" vs "XXL", etc.)
            const sizeMapping = {
              'xs': ['xs', 'extra small', 'extra-small', 'x-small', 'x small'],
              's': ['s', 'small'],
              'm': ['m', 'medium'],
              'l': ['l', 'large'],
              'xl': ['xl', 'x-large', 'x large', 'extra large', 'extra-large'],
              'xxl': ['xxl', '2xl', '2xl', 'x-large', 'x large', 'double xl', 'double-xl'],
              'xxxl': ['xxxl', '3xl', '3xl', 'triple xl', 'triple-xl'],
              '2xl': ['2xl', 'xxl', 'double xl', 'double-xl'],
              '3xl': ['3xl', 'xxxl', 'triple xl', 'triple-xl']
            };
            
            // Get all possible matches for selected sizes
            const getSizeMatches = (size) => {
              const normalized = size.toLowerCase().trim();
              const matches = [normalized];
              
              // Add mapped variations
              for (const [key, variations] of Object.entries(sizeMapping)) {
                if (variations.includes(normalized)) {
                  matches.push(key, ...variations);
                  break;
                }
              }
              
              return [...new Set(matches)]; // Remove duplicates
            };
            
            const mensSizeMatches = getSizeMatches(mensSize);
            const womensSizeMatches = getSizeMatches(womensSize);

            // Find variants matching the selected sizes for inventory tracking
            let mensVariant = null;
            let womensVariant = null;
            let mensVariantAvailable = null;
            let womensVariantAvailable = null;
            let mensVariantPreferred = null;
            let womensVariantPreferred = null;

            const sizeValues = [
              "xs",
              "s",
              "m",
              "l",
              "xl",
              "xxl",
              "xxxl",
              "2xl",
              "3xl",
              "extra small",
              "extra-small",
              "x-small",
              "x large",
              "x-large",
              "double xl",
              "double-xl",
              "triple xl",
              "triple-xl",
            ];

            if (!finalMensVariant || !finalWomensVariant) {
            // First pass: Check all variants (including unavailable)
            for (const variant of productVariants) {
              const option1 = (variant.option1 || '').toLowerCase().trim();
              const option2 = (variant.option2 || '').toLowerCase().trim();
              const option3 = (variant.option3 || '').toLowerCase().trim();
              
              // Check all options for flexible matching
              const allOptions = [option1, option2, option3].filter(opt => opt);
              
              // Find variants matching Men's Size (flexible matching)
              const matchesMensSize = mensSizeMatches.some(sizeMatch => 
                allOptions.some(opt => 
                  opt === sizeMatch || 
                  opt.includes(sizeMatch) || 
                  sizeMatch.includes(opt) ||
                  opt.replace(/[^a-z0-9]/g, '') === sizeMatch.replace(/[^a-z0-9]/g, '') // Remove special chars for comparison
                )
              );
              
              if (matchesMensSize) {
                // Prefer available variants
                if (variant.available) {
                  if (!mensVariantAvailable) {
                    mensVariantAvailable = variant;
                  }
                  // Prefer variants where size is NOT the first option
                  if (!mensVariantPreferred && !sizeValues.includes(option1)) {
                    mensVariantPreferred = variant;
                  }
                }
                // Fallback to unavailable variant if no available found
                if (!mensVariant) {
                  mensVariant = variant;
                }
              }
              
              // Find variants matching Women's Size (flexible matching)
              const matchesWomensSize = womensSizeMatches.some(sizeMatch => 
                allOptions.some(opt => 
                  opt === sizeMatch || 
                  opt.includes(sizeMatch) || 
                  sizeMatch.includes(opt) ||
                  opt.replace(/[^a-z0-9]/g, '') === sizeMatch.replace(/[^a-z0-9]/g, '')
                )
              );
              
              if (matchesWomensSize) {
                // Prefer available variants
                if (variant.available) {
                  if (!womensVariantAvailable) {
                    womensVariantAvailable = variant;
                  }
                  // Prefer variants where size is NOT the first option
                  if (!womensVariantPreferred && !sizeValues.includes(option1)) {
                    womensVariantPreferred = variant;
                  }
                }
                // Fallback to unavailable variant if no available found
                if (!womensVariant) {
                  womensVariant = variant;
                }
              }
            }

            if (!finalMensVariant) {
              finalMensVariant =
                mensVariantPreferred || mensVariantAvailable || mensVariant;
            }
            if (!finalWomensVariant) {
              finalWomensVariant =
                womensVariantPreferred || womensVariantAvailable || womensVariant;
            }
            }

            if (!finalMensVariant || !finalWomensVariant) {
              console.warn('Matching variants not found for sizes:', {
                mensSize: mensSize,
                womensSize: womensSize,
                mensVariantFound: !!finalMensVariant,
                womensVariantFound: !!finalWomensVariant,
                totalVariants: productVariants.length,
                availableVariants: productVariants.filter(v => v.available).length,
                variantOptions: productVariants.map(v => ({
                  id: v.id,
                  option1: v.option1,
                  option2: v.option2,
                  option3: v.option3,
                  available: v.available
                }))
              });
              
              // FIXED: Issue #3 - Better fallback when variants not found
              // Try to use default variant and add properties
              const defaultVariant = productVariants.find(v => v.available) || productVariants[0];
              
              if (defaultVariant) {
                console.info('Using default variant as fallback:', defaultVariant.id);
                const fallbackFormData = new FormData();
                fallbackFormData.append('id', defaultVariant.id);
                fallbackFormData.append('quantity', baseQuantity);
                fallbackFormData.append('properties[Men\'s Size]', mensSize);
                fallbackFormData.append('properties[Women\'s Size]', womensSize);
                
                if (sections.length > 0) {
                  fallbackFormData.append("sections", sections.join(','));
                  fallbackFormData.append("sections_url", sectionsUrl);
                }
                
                if (this.cart) {
                  this.cart.setActiveElement(document.activeElement);
                }
                
                const response = await fetch(`${routes?.cart_add_url}`, {
                  ...config,
                  body: fallbackFormData
                });
                const state = await response.text();
                const parsedState = JSON.parse(state);
                
                if (!parsedState.errors) {
                  this.updateCartUI(parsedState, sections);
                } else {
                  this.handleCartError(parsedState);
                }
                return;
              }
              
              // Final fallback: use original form data
              if (this.cart) {
                originalFormData.append("sections", sections.join(','));
                originalFormData.append("sections_url", sectionsUrl);
                this.cart.setActiveElement(document.activeElement);
              }
              const response = await fetch(`${routes?.cart_add_url}`, {
                ...config,
                body: originalFormData
              });
              const state = await response.text();
              const parsedState = JSON.parse(state);
              
              if (!parsedState.errors) {
                this.updateCartUI(parsedState, sections);
              } else {
                this.handleCartError(parsedState);
              }
              return;
            }
            
            // Strategy: Use actual size variants for inventory tracking
            // Same Shopify variant id only: quantity 2 on one line item; different ids: two requests

            if (
              finalMensVariant &&
              finalWomensVariant &&
              finalMensVariant.id === finalWomensVariant.id
            ) {
              // Same variant row: add variant with quantity 2
              const formData = new FormData();
              formData.append('id', finalMensVariant.id);
              formData.append('quantity', baseQuantity * 2); // Quantity 2 for inventory tracking
              formData.append('properties[Men\'s Size]', mensSize);
              formData.append('properties[Women\'s Size]', womensSize);
              
              if (sections.length > 0) {
                formData.append('sections', sections.join(','));
                formData.append('sections_url', sectionsUrl);
              }
              
              if (this.cart) {
                this.cart.setActiveElement(document.activeElement);
              }
              
              const response = await fetch(`${routes?.cart_add_url}`, {
                ...config,
                body: formData
              });
              
              const state = await response.text();
              const parsedState = JSON.parse(state);
              
              if (!parsedState.errors) {
                this.updateCartUI(parsedState, sections);
              } else {
                this.handleCartError(parsedState);
              }
            } else if (finalMensVariant && finalWomensVariant) {
              // Different sizes: add both variants for inventory tracking
              const addPromises = [];
              
              const mensFormData = new FormData();
              mensFormData.append('id', finalMensVariant.id);
              mensFormData.append('quantity', baseQuantity);
              mensFormData.append('properties[Men\'s Size]', mensSize);
              mensFormData.append('properties[Women\'s Size]', womensSize);
              
              if (sections.length > 0) {
                mensFormData.append('sections', sections.join(','));
                mensFormData.append('sections_url', sectionsUrl);
              }
              
              addPromises.push(
                fetch(`${routes?.cart_add_url}`, {
                  ...config,
                  body: mensFormData
                }).then(res => res.text())
              );
              
              const womensFormData = new FormData();
              womensFormData.append('id', finalWomensVariant.id);
              womensFormData.append('quantity', baseQuantity);
              womensFormData.append('properties[Men\'s Size]', mensSize);
              womensFormData.append('properties[Women\'s Size]', womensSize);
              
              if (sections.length > 0) {
                womensFormData.append('sections', sections.join(','));
                womensFormData.append('sections_url', sectionsUrl);
              }
              
              addPromises.push(
                fetch(`${routes?.cart_add_url}`, {
                  ...config,
                  body: womensFormData
                }).then(res => res.text())
              );
              
              const results = await Promise.all(addPromises);
              const lastResult = results[results.length - 1];
              const parsedState = JSON.parse(lastResult);
              
              if (!parsedState.errors) {
                this.updateCartUI(parsedState, sections);
              } else {
                this.handleCartError(parsedState);
              }
            }
            
            this.submitButton.removeAttribute("disabled");
            this.submitButton.classList.remove("btn-loading");
            const submitSpan = this.submitButton.querySelector("span");
            if (submitSpan) {
              submitSpan.classList.remove("hidden");
            }
            
          } catch (error) {
            console.error('Error adding dual size to cart:', error);
            
            // Fallback: try normal add to cart
            try {
              if (this.cart) {
                originalFormData.append("sections", sections.join(','));
                originalFormData.append("sections_url", sectionsUrl);
                this.cart.setActiveElement(document.activeElement);
              }
              const response = await fetch(`${routes?.cart_add_url}`, {
                ...config,
                body: originalFormData
              });
              const state = await response.text();
              const parsedState = JSON.parse(state);
              
              if (!parsedState.errors) {
                this.updateCartUI(parsedState, sections);
              } else {
                this.handleCartError(parsedState);
              }
            } catch (fallbackError) {
              console.error('Fallback add to cart also failed:', fallbackError);
              this.handleCartError({ errors: 'Unable to add product to cart. Please try again.' });
            }
            
            this.submitButton.removeAttribute("disabled");
            this.submitButton.classList.remove("btn-loading");
            const submitSpan = this.submitButton.querySelector("span");
            if (submitSpan) {
              submitSpan.classList.remove("hidden");
            }
          }
        }
        
        updateCartUI(parsedState, sections) {
          if (this.cart && sections.length > 0) {
            this.cart.getSectionsToRender().forEach((section) => {
              const elementToReplace = document.getElementById(section.id);
              if (elementToReplace && parsedState.sections && parsedState.sections[section.id]) {
                const html = new DOMParser().parseFromString(
                  parsedState.sections[section.id],
                  "text/html"
                );
                const cartContent = html.querySelector("#form-mini-cart");
                if (cartContent) {
                  elementToReplace.innerHTML = cartContent.innerHTML;
                }
              }
            });
            
            // Update cart count
            fetch("/cart.json")
              .then((res) => res.json())
              .then((cart) => {
                if (cart.item_count != undefined) {
                  document.querySelectorAll(".cart-count").forEach((el) => {
                    if (el.classList.contains('cart-count-drawer')) {
                      el.innerHTML = `(${cart.item_count})`;
                    } else {
                      el.innerHTML = cart.item_count;
                    }
                  });
                  
                  if (document.querySelector("header-total-price")) {
                    document.querySelector("header-total-price").updateTotal(cart);
                  }
                  
                }
              });
            
            const countdown = this.cart.querySelector(".cart-countdown-time");
            if (countdown) {
              const html = new DOMParser().parseFromString(
                parsedState.sections[this.cart.getSectionsToRender()[0].id] || '',
                "text/html"
              );
              const html_countdown = html.querySelector(".cart-countdown-time");
              if (html_countdown) {
                countdown.innerHTML = html_countdown.innerHTML;
                this.cart.countdownTimer();
              }
            }
            
            this.cart.cartAction();
            this.cart.open();
          }
        }
        
        handleCartError(parsedState) {
          const content = document.querySelector(".form-infor .add-cart-error");
          if (!content) return;
          
          const pswp = document.querySelector('.pswp__button--bls--close');
          if (pswp) {
            pswp.click();
          }
          
          if (parsedState.errors) {
            var error_message = EasyDialogBox.create(
              "add_cart_error",
              "dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading",
              "",
              content.innerHTML
            );
            error_message.onClose = error_message.destroy;
            error_message.show();
          }
        }
  
        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;
          this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector(".product-form__error-message-wrapper");
          if (!this.errorMessageWrapper) return;
          this.errorMessage =
            this.errorMessage ||
            this.errorMessageWrapper.querySelector(
              ".product-form__error-message"
            );
  
          this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
  
          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    );
  }
  
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector("input");
      this.changeEvent = new Event("change", { bubbles: true });
      this.querySelectorAll("button").forEach((button) =>
        button.addEventListener("click", this.onButtonClick.bind(this))
      );
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
      event.currentTarget.name === "plus"
        ? this.input.stepUp()
        : this.input.stepDown();
      if (previousValue !== this.input.value)
        this.input.dispatchEvent(this.changeEvent);
    }
  }
  customElements.define("quantity-input", QuantityInput);
  
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector(
          'input[name="language_code"], input[name="country_code"]'
        ),
        button: this.querySelector(".button-localization"),
        panel: this.querySelector("ul"),
      };
      this.elements.button.addEventListener(
        "click",
        this.openSelector.bind(this)
      );
      this.elements.button.addEventListener(
        "focusout",
        this.closeSelector.bind(this)
      );
      this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
      this.querySelectorAll("a").forEach((item) =>
        item.addEventListener("click", this.onItemClick.bind(this))
      );
      this.onBodyClick = this.handleBodyClick.bind(this);
      this.initMenuMobile();
    }
  
    handleBodyClick(evt) {
      const target = evt.target;
      if (target != this && !target.closest("localization-form")) {
        this.hidePanel();
      }
    }
  
    hidePanel() {
      document.body.removeEventListener("click", this.onBodyClick);
      this.elements.button.classList.remove("opend");
      this.elements.panel.classList.add("hidden");
    }
  
    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== "ESCAPE") return;
      this.hidePanel();
      this.elements.button.focus();
    }
  
    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector("form");
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  
    openSelector() {
      if (this.elements.button.classList.contains("opend")) {
        this.hidePanel();
      } else {
        document.body.addEventListener("click", this.onBodyClick);
        this.elements.button.focus();
        for (var item of document.querySelectorAll(".button-localization")) {
          item.classList.remove("opend");
        }
        for (var item of document.querySelectorAll(".disclosure__list")) {
          item.classList.add("hidden");
        }
        this.elements.button.classList.add("opend");
        this.elements.panel.classList.remove("hidden");
      }
    }
  
    closeSelector(event) {
      const shouldClose =
        event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }

    initMenuMobile(){
      let windowWidth = window.innerWidth;
      const _this = this;
      window.addEventListener("resize", function () {
         windowWidth = window.innerWidth;
        ac(windowWidth,_this);
      });
      function ac(windowWidth,_this) {
        if(windowWidth < 1024){
          const limitShow = 9;
          const lineItem = Array.from(_this.getElementsByClassName('disclosure__item-mobile'));
          if (lineItem.length === 0) return;
          if (lineItem.length > limitShow) {
            lineItem.forEach((element, index) => {
              if (index > limitShow - 1) {
                const item = lineItem[index];
                if (item.classList.contains("disclosure-menu-link")) {
                  return;
                }
                item.classList.add("disclosure-link");
                item.style.display = "none";
              }
            });
            _this.querySelector('.disclosure-menu-link').style.display = 'block';
            if (_this.querySelector('.disclosure-menu-link a')) {
              _this.querySelector('.disclosure-menu-link a').addEventListener('click', (e) => {
                e.preventDefault();
                const target = e.currentTarget;
                const parent = target.parentElement;
                if (!parent.classList.contains("expanding")) {
                  parent.classList.add("expanding");
                  for (var item of _this.querySelectorAll(
                    ".disclosure__item-mobile.disclosure-link"
                  )) {
                    showAnime(item);
                  }
                  target.innerText = window.action.show_less
                } else {
                  parent.classList.remove("expanding");
                  for (var item of _this.querySelectorAll(
                    ".disclosure__item-mobile.disclosure-link"
                  )) {
                    hideAnime(item);
                  }
                  target.innerText = window.action.show_all
                }
              },false)
            }
          }else {
            _this.querySelector(".disclosure-menu-link").style.display = "none";
          }
        }
      }
      if(windowWidth < 1024){
        const limitShow = 9;
        const lineItem = Array.from(_this.getElementsByClassName('disclosure__item-mobile'));
        if (lineItem.length === 0) return;
        if (lineItem.length > limitShow) {
          lineItem.forEach((element, index) => {
            if (index > limitShow - 1) {
              const item = lineItem[index];
              if (item.classList.contains("disclosure-menu-link")) {
                return;
              }
              item.classList.add("disclosure-link");
              item.style.display = "none";
            }
          });
          _this.querySelector('.disclosure-menu-link').style.display = 'block';
          if (_this.querySelector('.disclosure-menu-link span')) {
            _this.querySelector('.disclosure-menu-link span').addEventListener('click', (e) => {
              e.preventDefault();
              const target = e.currentTarget;
              const parent = target.parentElement;
              if (!parent.classList.contains("expanding")) {
                parent.classList.add("expanding");
                for (var item of _this.querySelectorAll(
                  ".disclosure__item-mobile.disclosure-link"
                )) {
                  showAnime(item);
                }
                target.innerText = window.action.show_less
              } else {
                parent.classList.remove("expanding");
                for (var item of _this.querySelectorAll(
                  ".disclosure__item-mobile.disclosure-link"
                )) {
                  hideAnime(item);
                }
                target.innerText = window.action.show_all
              }
            },false)
          }
        }else {
          _this.querySelector(".disclosure-menu-link").style.display = "none";
        }
      }
      
    }
  }
  customElements.define("localization-form", LocalizationForm);
  
  class CartNotification extends HTMLElement {
    constructor() {
      super();
      this.notification = document.getElementById("bls-header_minicart");
      this.giftwrap = document.querySelector(".bls__add-giftwrap");
      this.cartCountDown = document.querySelector(".cart-countdown-time");
      this.cartUpsellBeside = document.querySelector('.bls-recommendations-beside')
      this.startTime = Date.now();
      this.querySelectorAll(".bls-minicart-wrapper .close-button").forEach(
        (closeButton) =>
          closeButton.addEventListener("click", this.close.bind(this))
      );
      document
        .querySelectorAll(".bls-minicart-action", ".close-cart")
        .forEach((navToggle) => {
          navToggle.addEventListener(
            "click",
            (e) => {
              e.preventDefault();
              if (
                this.notification.classList.contains("bls__opend-popup-header")
              ) {
                this.close();
              } else {
                this.open();
              }
            },
            false
          );
        });
      this.currentItemCount = Array.from(
        this.querySelectorAll('[name="updates[]"]')
      ).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value),
        0
      );
  
      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);
      this.addEventListener("change", this.debouncedOnChange.bind(this));
      this.cartAction();
      this.countdownTimer();
      this.addonsUpdate();
    }
  
    cartAction() {
      document.querySelectorAll(".close-cart").forEach((navToggle) => {
        navToggle.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            if (this.notification.classList.contains("bls__opend-popup-header")) {
              this.close();
            }
          },
          false
        );
      });
      document.querySelectorAll(".bls__cart-addons button").forEach((button) => {
        button.removeEventListener("click", this.cartAddons.bind(this), false);
        button.addEventListener("click", this.cartAddons.bind(this), false);
      });
  
      document
        .querySelectorAll(".bls__addon-actions .btn-save")
        .forEach((button) => {
          button.removeEventListener(
            "click",
            this.cartAddonsSave.bind(this),
            false
          );
          button.addEventListener("click", this.cartAddonsSave.bind(this), false);
        });
  
      document.querySelectorAll(".bls__add-giftwrap").forEach((giftwrap) => {
        giftwrap.removeEventListener(
          "click",
          this.addGiftwrapClick.bind(this),
          false
        );
        giftwrap.addEventListener(
          "click",
          this.addGiftwrapClick.bind(this),
          false
        );
      });
  
      document.querySelectorAll(".bls-minicart-item-edit").forEach((edit) => {
        edit.removeEventListener("click", this.cartEditItem.bind(this), false);
        edit.addEventListener("click", this.cartEditItem.bind(this), false);
      });
  
      const conditions = document.getElementById("conditions_form_minicart");
      const bpb = document.querySelector(".bls-btn-checkout");
      if (conditions) {
        if (getCookie("term_conditions")) {
          conditions.setAttribute('checked','')
          if (bpb) {
            bpb.removeAttribute("disabled");
          }
        }else{
          conditions.addEventListener("change", (event) => {
            setCookie('term_conditions', 1, 1);
            
            if (bpb) {
              if (event.currentTarget.checked) {
                bpb.removeAttribute("disabled");
              } else {
                bpb.setAttribute("disabled", "disabled");
              }
            }
          });
        }
      }
  
      document
        .querySelectorAll(".bls__addon-actions .btn-cancel")
        .forEach((addonCancel) => {
          addonCancel.addEventListener(
            "click",
            (e) => {
              e.preventDefault();
              const target = e.currentTarget;
              target.closest(".bls__addon").classList.remove("is-open");
              target
                .closest(".bls-minicart-wrapper")
                .classList.remove("addons-open");
            },
            false
          );
        });
  
      document
        .querySelectorAll(".bls__addon-actions .btn-cancel")
        .forEach((addonCancel) => {
          addonCancel.addEventListener(
            "click",
            (e) => {
              e.preventDefault();
              const target = e.currentTarget;
              target.closest(".bls__addon").classList.remove("is-open");
              target
                .closest(".bls-minicart-wrapper")
                .classList.remove("addons-open");
            },
            false
          );
        });
    }
  
    addonsUpdate() {
      const address_country = document.getElementById("address_country");
      const address_province = document.getElementById("address_province");
      if (address_country && address_province) {
        new Shopify.CountryProvinceSelector(
          "address_country",
          "address_province",
          { hideElement: "address_province_container" }
        );
      }
  
      const bls__discount_code = document.querySelector(".bls__discount_code");
      const code = localStorage.getItem("discount_code");
      if (code && bls__discount_code) {
        document.querySelector(".bls__discount_code").value = code;
      }
    }
  
    cartAddons(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const open = target.getAttribute("data-open");
      if (
        !document.getElementById("bls__" + open).classList.contains("is-open")
      ) {
        document.getElementById("bls__" + open).classList.add("is-open");
        target.closest(".bls-minicart-wrapper").classList.add("addons-open");
        if (open == "shipping") {
          const address_country = document.getElementById("address_country");
          const address_province = document.getElementById("address_province");
          if (address_country && address_province) {
            new Shopify.CountryProvinceSelector(
              "address_country",
              "address_province",
              { hideElement: "address_province_container" }
            );
          }
        }
      } else {
        document.getElementById("bls__" + open).classList.remove("is-open");
        target.closest(".bls-minicart-wrapper").classList.remove("addons-open");
      }
    }
  
    cartEditItem(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const key = target.getAttribute("data-key");
      const quantity = target.getAttribute("data-quantity");
      const href = target.getAttribute("href");
      const variant =
        href.indexOf("?") > -1 ||
        href.indexOf("?variant=") > -1 ||
        href.indexOf("&variant=") > -1
          ? "&"
          : "/?";
      target.closest(".cart-item").classList.add("loadding");
      fetch(`${window.shopUrl}${href}${variant}section_id=cart-quick-edit`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((response) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(response, "text/html")
            .getElementById("shopify-section-cart-quick-edit");
          var quick_edit = EasyDialogBox.create(
            "cart-edit-item",
            "dlg dlg-disable-footer dlg-disable-drag",
            cartStrings?.quick_edit,
            resultsMarkup.innerHTML
          );
          quick_edit.onClose = quick_edit.destroy;
          quick_edit.show();
        })
        .catch((error) => {
          throw error;
        })
        .finally(() => {
          if (document.querySelector("[data-template-quick-cart-edit]")) {
            document
              .querySelector("[data-template-quick-cart-edit]")
              .setAttribute("data-line", key);
          }
          if (
            document.querySelector(
              ".product-form-quick-edit quantity-input input"
            )
          ) {
            document.querySelector(
              ".product-form-quick-edit quantity-input input"
            ).value = quantity;
          }
          target.closest(".cart-item").classList.remove("loadding");
          BlsColorSwatchesShopify.init();
          BlsLazyloadImg.init();
        });
    }
  
    cartAddonsSave(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const action = target.getAttribute("data-action");
      if (action == "coupon") {
        const value = document.querySelector(".bls__discount_code").value;
        localStorage.setItem("discount_code", value);
        document.getElementById("bls__" + action).classList.remove("is-open");
        document
          .querySelector(".bls-minicart-wrapper")
          .closest(".bls-minicart-wrapper")
          .classList.remove("addons-open");
      } else if (action == "note") {
        const body = JSON.stringify({
          note: document.querySelector(".bls__cart-note").value,
        });
        fetch(`${routes?.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        document.getElementById("bls__" + action).classList.remove("is-open");
        document
          .querySelector(".bls-minicart-wrapper")
          .closest(".bls-minicart-wrapper")
          .classList.remove("addons-open");
      } else if (action == "shipping") {
        var e = {};
        (e.zip = document.querySelector("#AddressZip").value || ""),
          (e.country = document.querySelector("#address_country").value || ""),
          (e.province = document.querySelector("#address_province").value || ""),
          this._getCartShippingRatesForDestination(e);
      }
    }
  
    _getCartShippingRatesForDestination(event) {
      fetch(
        `${window.Shopify.routes.root}cart/shipping_rates.json?shipping_address%5Bzip%5D=${event.zip}&shipping_address%5Bcountry%5D=${event.country}&shipping_address%5Bprovince%5D=${event.province}`
      )
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const message = document.querySelector(".bls__addon-message");
          for (var item of document.querySelectorAll(".bls__addon-message p")) {
            item.remove();
          }
          const {showDeliveryDays,deliveryDayOne,deliveryDaysOther} = message.dataset;
          const parsedState = JSON.parse(state);
          if (parsedState && parsedState.shipping_rates) {
            if (parsedState.shipping_rates.length > 0) {
              message.classList.remove("error", "warning");
              message.classList.add("success");
              const p = document.createElement("p");
              p.innerText = cartStrings?.shipping_rate.replace(
                "{{address}}",
                event.zip + ", " + event.country + " " + event.province
              );
              message.appendChild(p);
              parsedState.shipping_rates.map((rate) => {
                let daysShipping = "";
                if (rate.delivery_days.length > 0 && showDeliveryDays == 'true') {
                  let typeDay = deliveryDayOne;
                  const day = rate.delivery_days[0];
                  const dayAt = rate.delivery_days.at(-1);
                  if (day > 1) typeDay = deliveryDaysOther;
                  if (day === dayAt) {
                    daysShipping = `(${day} ${typeDay})`
                  }else{
                    daysShipping = `(${day} - ${dayAt} ${typeDay})`
                  }
                }
                const rateNode = document.createElement("p");
                rateNode.innerHTML =
                  rate.name +
                  ": " +
                  Shopify.formatMoney(rate.price, cartStrings?.money_format)+" "+ daysShipping;
                message.appendChild(rateNode);
              });
            } else {
              message.classList.remove("error", "success");
              message.classList.add("warning");
              const p = document.createElement("p");
              p.innerText = cartStrings?.no_shipping;
              message.appendChild(p);
            }
          } else {
            message.classList.remove("success", "warning");
            message.classList.add("error");
            Object.entries(parsedState).map((error) => {
              const message_error = `${error[1][0]}`;
              const p = document.createElement("p");
              p.innerText = message_error;
              message.appendChild(p);
            });
          }
        })
        .catch((error) => {
          throw error;
        });
    }
  
    addGiftwrapClick(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const variant_id = target.getAttribute("data-variant-id");
      const config = fetchConfig("json");
      config.body = JSON.stringify({
        id: Number(variant_id),
        quantity: 1,
        sections: this.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      });
      target.classList.add("loading");
      fetch(`${routes?.cart_add_url}`, config)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          fetch("/cart.json")
            .then((res) => res.json())
            .then((cart) => {
              if (cart.item_count != undefined) {
                document.querySelectorAll(".cart-count").forEach((el) => {
                  if (el.classList.contains('cart-count-drawer')) {
                    el.innerHTML = `(${cart.item_count})`;
                    }else{
                    el.innerHTML = cart.item_count;
                    }
                });
                if (document.querySelector("header-total-price")) {
                  document.querySelector("header-total-price").updateTotal(cart);
                }
              }
            })
            .catch((error) => {
              throw error;
            });
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace = document.getElementById(section.id);
            const html = new DOMParser().parseFromString(
              parsedState.sections[section.id],
              "text/html"
            );
            elementToReplace.innerHTML =
              html.querySelector("#form-mini-cart").innerHTML;
              const cartUpsell = document.querySelector('.bls-recommendations-beside');
                const html_cartUpsell = html.querySelector('.bls-recommendations-beside');
                const html_cartUpselSelected = html.querySelector('.bls-recommendations-beside-selected');
                var counteSelect;
                if (cartUpsell && html_cartUpsell) {
                  if (html_cartUpselSelected) {
                    counteSelect = Array.from(html_cartUpselSelected.getElementsByClassName('bls-cart-upsell-item'));
                    if (counteSelect.length == 0) {
                      cartUpsell.classList.remove('is-opend')
                    }
                  }
                  
                  if (!counteSelect || counteSelect.length != 0) {
                    setTimeout(() => {
                      cartUpsell.classList.add("is-opend");
                    }, 1500);
                  }
                  cartUpsell.innerHTML = html_cartUpsell.innerHTML
                }
          });
          this.cartAction();
        })
        .catch((e) => {
          throw e;
        })
        .finally(() => {
          document
            .querySelector(".bls__add-giftwrap")
            .classList.remove("loading");
          document.getElementById("bls__gift").classList.remove("is-open");
          document
            .querySelector(".bls-minicart-wrapper")
            .classList.remove("addons-open");
          Shopify.termsConditionsAction();
          BlsLazyloadImg.init();
          BlsSettingsSwiper.init();
          
        });
    }
  
    onChange(event) {
      if (event.target.getAttribute("name") == "updates[]")
        this.updateQuantity(
          event.target.dataset.id,
          event.target.value,
          event.target.dataset.value,
          event.target,
          document.activeElement.getAttribute("name")
        );
    }
  
    updateQuantity(id, quantity, currentQuantity, _this, name) {
      quantity = quantity ? quantity : 0;
      const body = JSON.stringify({
        id,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      });
      this.notification.classList.add("start", "loading");
      // Replaced by querySelectorAll in the `.then` block
      fetch(`${routes?.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          if (parsedState.item_count != undefined) {
            document.querySelectorAll(".cart-count").forEach((el) => {
              if (el.classList.contains('cart-count-drawer')) {
                el.innerHTML = `(${parsedState.item_count})`;
                }else{
                el.innerHTML = parsedState.item_count;
                }
            });
            if (document.querySelector("header-total-price")) {
              document
                .querySelector("header-total-price")
                .updateTotal(parsedState);
            }
          }
          if (document.querySelector(".quantity__label")) {
            const items = parsedState.items;
            const pro_id = document.querySelector(".quantity__label").getAttribute('data-pro-id');
            var variant_id,variant_quantity;
            items.forEach(function(item){
              variant_id = item.variant_id;
              if (variant_id == pro_id) {
                document.querySelector(".quantity-cart").innerHTML = item.quantity;
                document.querySelector(".quantity__label").classList.remove("hidden");
                variant_quantity = pro_id;
                return;
              }
            });
            if (!variant_quantity) {
              document.querySelector(".quantity-cart").innerHTML = 0;
              document.querySelector(".quantity__label").classList.add("hidden");
            }
          }
          
          if (document.querySelector("header-total-price")) {
            document.querySelector("header-total-price").updateTotal(parsedState);
          }
          if (parsedState.item_count == 0 && this.cartCountDown) {
            this.cartCountDown.querySelector(".countdown-message").remove();
          }
          if (parsedState.item_count == 0 && this.cartUpsellBeside) {
            if (this.cartUpsellBeside.classList.contains('is-opend')) {
            this.cartUpsellBeside.classList.remove('is-opend');
              }
          }
          if (!parsedState.error && parsedState.item_count != undefined) {
            this.getSectionsToRender().forEach((section) => {
              const elementToReplace = document.getElementById(section.id);
              const html = new DOMParser().parseFromString(
                parsedState.sections[section.id],
                "text/html"
              );
              elementToReplace.innerHTML =
                html.querySelector("#form-mini-cart").innerHTML;
            });
          } else {
            const content = document.querySelector(".form-infor .add-cart-error");
            if (!content) return;
            var error_message = EasyDialogBox.create(
              "add_cart_error",
              "dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading",
              "",
              content.innerHTML
            );
            error_message.onClose = error_message.destroy;
            error_message.show();
            if (!_this) return;
            _this.value = currentQuantity;
          }
          this.cartAction();
        })
        .catch((e) => {
          throw e;
        })
        .finally(() => {
          Shopify.termsConditionsAction();
          this.notification.classList.add("finish");
          setTimeout(function () {
            this.cart = document.querySelector("cart-notification");
            this.cart
              .querySelector(".header_minicart")
              .classList.remove("start", "loading", "finish");
          }, 500);
          BlsLazyloadImg.init();
          BlsSettingsSwiper.init();
          
        });
    }
  
    countdownTimer() {
      if (!this.cartCountDown) return;
      const duration = Number(this.cartCountDown.dataset.countdownTime) || 5;
      const message = this.cartCountDown.dataset.timeoutMessage;
      const endTime = this.startTime + duration * 60 * 1000;
      const countdown_timer = setInterval(() => {
        if (!document.querySelector(".cart-countdown-time .countdown-message")) {
          clearInterval(countdown_timer);
        } else {
          if (this.startTime > endTime) {
            this.cartCountDown.querySelector(".countdown-message").innerHTML =
              message;
            clearInterval(countdown_timer);
          } else {
            var distance = endTime - this.startTime;
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            document.querySelector(".countdown-timer-minute").innerHTML = minutes;
            document.querySelector(".countdown-timer-sec").innerHTML = seconds;
          }
          this.startTime += 1000;
        }
      }, 1000);
    }
  
    open() {
      this.notification.classList.add("bls__opend-popup-header");
      document.documentElement.classList.add("hside_opened");
      this.notification.addEventListener(
        "transitionend",
        () => {
          this.notification.focus();
        },
        { once: true }
      );
      document.body.addEventListener("click", this.onBodyClick);
    }

    closeBeside(){
      document.querySelector('.bls-recommendations-beside').classList.remove('is-opend');
    }
  
    close() {
      this.notification.classList.remove("bls__opend-popup-header");
      document.documentElement.classList.remove("hside_opened");
      if (document.querySelector('.bls-recommendations-beside')) {
        document.querySelector('.bls-recommendations-beside').classList.remove('is-opend');
      }
      document.body.removeEventListener("click", this.onBodyClick);
      for (var item of document.querySelectorAll(".bls__addon")) {
        item.classList.remove("is-open");
      }
      for (var item of document.querySelectorAll(".bls-minicart-wrapper")) {
        item.classList.remove("addons-open");
      }
    }
  
    getSectionsToRender() {
      return [
        {
          id: "form-mini-cart",
        },
      ];
    }
  
    getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
  
    setActiveElement(element) {
      this.activeElement = element;
    }
  }
  customElements.define("cart-notification", CartNotification);
  
  class MiniCartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", (event) => {
        event.preventDefault();
        const wishlist_items = JSON.parse(
          localStorage.getItem("bls__wishlist-items")
        );
        const productHandle = this.dataset.productHandle;
        let index = wishlist_items?.indexOf(productHandle);
        if (this.classList.contains("bls-action-add-wishlist") ) {
            if (index == -1 || index == undefined) {
              this.closest(".cart-item").querySelector('.bls-minicart-wishlist').style.display = "block"
              this.closest(".cart-item").querySelector('.bls-minicart-product-info').style.display = "none"
            }else{
              const cartItems = this.closest("cart-notification");
              cartItems.updateQuantity(this.dataset.index, 0);
            }
        }
        else{
          const cartItems = this.closest("cart-notification");
          cartItems.updateQuantity(this.dataset.index, 0);
        }
        
      });
    }
  }
  customElements.define("mini-cart-remove-button", MiniCartRemoveButton);

    
  class MiniCartWishlistAction extends HTMLElement {
    constructor() {
      super();
      this.actionRemoveWishlist()
      this.actionAddWishlist()
      this.actionClose()
    }

    actionRemoveWishlist(){
      this.querySelector('.btn-minicart-remove-js').addEventListener("click", (event) => {
        event.preventDefault();
        const target = event.currentTarget
        this.eventRemove(target)
        
      });
    }

    actionAddWishlist(){
      this.querySelector('.btn-minicart-add-wishlist-js').addEventListener("click", (event) => {
        event.preventDefault();
        BlsSubActionProduct.handleWishlistFunctionClick(event);
        const target = event.currentTarget
        this.eventRemove(target)
      })
    }

    eventRemove(target){
      const cartItems = target.closest("cart-notification");
      cartItems.updateQuantity(target.dataset.index, 0);
    }

    actionClose(){
      document.querySelectorAll('.cart-close-wishlist').forEach(items => {
        items.addEventListener('click', (e) => {
          const target = e.currentTarget;
          e.preventDefault();
          target.closest(".cart-item").querySelector('.bls-minicart-wishlist').style.display = "none"
          target.closest(".cart-item").querySelector('.bls-minicart-product-info').style.display = "block"
        })
      })
    }
  }
  customElements.define("minicart-wishlist-action", MiniCartWishlistAction);
  
  class VariantSelectsQuickEdit extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll(".bls__option-swatch").forEach((button) =>
        button.addEventListener("click", this.onVariantChange.bind(this), false)
      );
    }
  
    onVariantChange(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const value = target.getAttribute("data-value");
      for (var item of target
        .closest("fieldset")
        .querySelectorAll(".bls__option-swatch")) {
        item.classList.remove("active");
      }
      target.classList.toggle("active");
      target
        .closest("fieldset")
        .querySelector(".swatch-selected-value").textContent = value;
      this.options = Array.from(
        this.querySelectorAll(".bls__option-swatch.active"),
        (select) => select.getAttribute("data-value")
      );
      this.updateMasterId();
      this.toggleAddButton(true, "", false);
      if (!this.currentVariant) {
        this.toggleAddButton(true, "", true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateVariantInput();
        this.renderProductInfo();
      }
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      const form = document.getElementById(
        `product-form-quick-edit-${this.dataset.section}`
      );
      form.querySelector(".product__media img").removeAttribute("srcset");
      form
        .querySelector(".product__media img")
        .setAttribute(
          "src",
          this.currentVariant.featured_media.preview_image.src
        );
    }
  
    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-quick-edit-${this.dataset.section}`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }
  
    renderProductInfo() {
      if (!this.currentVariant) return;
      const compare_at_price = this.currentVariant.compare_at_price;
      const price = this.currentVariant.price;
      const price_format = Shopify.formatMoney(
        this.currentVariant.price,
        cartStrings?.money_format
      );
      const form = document.getElementById(
        `product-form-quick-edit-${this.dataset.section}`
      );
      form.querySelector(".price__regular .price").innerHTML = price_format;
      const bls__price = form.querySelector(".bls__price");
      bls__price.classList.remove("price--sold-out", "price--on-sale");
      bls__price
        .querySelector(".price__regular .price")
        .classList.remove("special-price");
      if (compare_at_price && compare_at_price > price) {
        const compare_format = Shopify.formatMoney(
          compare_at_price,
          cartStrings?.money_format
        );
        if (!bls__price.querySelector(".compare-price")) {
          var ps = bls__price.querySelector(".price__sale");
          var sp = document.createElement("span");
          var cp = document.createElement("s");
          cp.classList.add("price-item", "compare-price");
          sp.appendChild(cp);
          if (ps) {
            ps.appendChild(sp);
          }
        }
        if (bls__price.querySelector(".compare-price")) {
          bls__price.querySelector(".compare-price").innerHTML = compare_format;
        }
        bls__price.classList.add("price--on-sale");
        bls__price
          .querySelector(".price__regular .price")
          .classList.add("special-price");
      } else if (!this.currentVariant.available) {
        bls__price.classList.add("price--sold-out");
      }
      this.toggleAddButton(
        !this.currentVariant.available,
        window.variantStrings?.soldOut
      );
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(
        `product-form-quick-edit-${this.dataset.section}`
      );
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      const buttonPayment = productForm.querySelector('.bls__product-dynamic-checkout');
      if (!addButton) return;
  
      if (disable) {
        addButton.setAttribute("disabled", "disabled");
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute("disabled");
        addButtonText.textContent = window.variantStrings?.addToCart;
      }
  
      if (!modifyClass) return;
    }
  
    setUnavailable() {
      const button = document.getElementById(
        `product-form-quick-edit-${this.dataset.section}`
      );
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings?.unavailable;
      if (price) price.classList.add("visibility-hidden");
    }
  
    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define("variant-radios-quick-edit", VariantSelectsQuickEdit);
  
  if (!customElements.get("product-form-quick-edit")) {
    customElements.define(
      "product-form-quick-edit",
      class ProductForm extends HTMLElement {
        constructor() {
          super();
          this.form = this.querySelector("form");
          this.form.querySelector("[name=id]").disabled = false;
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
          this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");
          this.submitButton = this.querySelector('[type="submit"]');
          if (document.querySelector("cart-drawer"))
            this.submitButton.setAttribute("aria-haspopup", "dialog");
        }
  
        onSubmitHandler(evt) {
          evt.preventDefault();
          this.handleErrorMessage();
          this.submitButton.setAttribute("disabled", true);
          this.submitButton.classList.add("btn-loading");
          const quick = document.getElementById("product-form-quick-edit");
          const id = quick.getAttribute("data-line");
          const quantity = 0;
          const config_change = fetchConfig("json");
          config_change.body = JSON.stringify({
            id,
            quantity,
          });
          fetch(`${routes?.cart_change_url}`, config_change)
            .then((response) => {
              return response.text();
            })
            .catch((e) => {
              throw e;
            })
            .finally(() => {
              this.addCartAdd();
            });
        }
  
        addCartAdd() {
          const config = fetchConfig("json");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];
          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
          fetch(`${routes?.cart_add_url}`, config)
            .then((response) => {
              return response.text();
            })
            .then((state) => {
              this.submitButton.setAttribute("disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              fetch("/cart.json")
                .then((res) => res.json())
                .then((cart) => {
                  if (cart.item_count != undefined) {
                    document.querySelectorAll(".cart-count").forEach((el) => {
                      if (el.classList.contains('cart-count-drawer')) {
                        el.innerHTML = `(${cart.item_count})`;
                        }else{
                        el.innerHTML = cart.item_count;
                        }
                    });
                    if (document.querySelector("header-total-price")) {
                      document
                        .querySelector("header-total-price")
                        .updateTotal(cart);
                    }
                  }
                })
                .catch((error) => {
                  throw error;
                });
              const parsedState = JSON.parse(state);
              if (!parsedState.errors) {
                this.cart.getSectionsToRender().forEach((section) => {
                  const elementToReplace = document.getElementById(section.id);
                  const html = new DOMParser().parseFromString(
                    parsedState.sections[section.id],
                    "text/html"
                  );
                  elementToReplace.innerHTML =
                    html.querySelector("#form-mini-cart").innerHTML;
                  const countdown = this.cart.querySelector(
                    ".cart-countdown-time"
                  );
                  const html_countdown = html.querySelector(
                    ".cart-countdown-time"
                  );
                  if (countdown && html_countdown) {
                    countdown.innerHTML = html_countdown.innerHTML;
                    this.cart.countdownTimer();
                  }
                  const cartUpsell = this.cart.querySelector('.bls-recommendations-beside');
                const html_cartUpsell = html.querySelector('.bls-recommendations-beside');
                const html_cartUpselSelected = html.querySelector('.bls-recommendations-beside-selected');
                var counteSelect;
                if (cartUpsell && html_cartUpsell) {
                  if (html_cartUpselSelected) {
                    counteSelect = Array.from(html_cartUpselSelected.getElementsByClassName('bls-cart-upsell-item'));
                    if (counteSelect.length == 0) {
                      cartUpsell.classList.remove('is-opend')
                    }
                  }
                  
                  if (!counteSelect || counteSelect.length != 0) {
                    setTimeout(() => {
                      cartUpsell.classList.add("is-opend");
                    }, 1500);
                  }
                  cartUpsell.innerHTML = html_cartUpsell.innerHTML
                }
                });
                this.cart.cartAction();
                document.querySelector(".dlg-close-x").click();
              } else {
                const content = document.querySelector(
                  ".form-infor .add-cart-error"
                );
                if (!content) return;
                var error_message = EasyDialogBox.create(
                  "add_cart_error",
                  "dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading",
                  "",
                  content.innerHTML
                );
                let cart_quick_edit = EasyDialogBox.getById("cart-edit-item_0");
                if (cart_quick_edit) {
                  cart_quick_edit.onHide = cart_quick_edit.destroy;
                  cart_quick_edit.hide();
                }
                error_message.onClose = error_message.destroy;
                error_message.show();
              }
            })
            .catch((e) => {
              throw e;
            })
            .finally(() => {
              this.submitButton.classList.remove("btn-loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error) this.submitButton.removeAttribute("disabled");
              this.submitButton.querySelector("span").classList.remove("hidden");
              Shopify.termsConditionsAction();
              BlsLazyloadImg.init();
            });
        }
  
        handleErrorMessage(errorMessage = false) {
          this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector(".product-form__error-message-wrapper");
          if (!this.errorMessageWrapper) return;
          this.errorMessage =
            this.errorMessage ||
            this.errorMessageWrapper.querySelector(
              ".product-form__error-message"
            );
  
          this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
  
          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    );
  }
  
  class VariantRadiosQuickview extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll(".bls__option-swatch").forEach((button) =>
        button.addEventListener("click", this.onVariantChange.bind(this), false)
      );
      this.actionDropdownSwatches();
    }
  
    onVariantChange(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const value = target.getAttribute("data-value");
      for (var item of target
        .closest("fieldset")
        .querySelectorAll(".bls__option-swatch")) {
        item.classList.remove("active");
      }
      target.classList.toggle("active");
      target
        .closest("fieldset")
        .querySelector(".swatch-selected-value").textContent = value;
      this.options = Array.from(
        this.querySelectorAll(".bls__option-swatch.active"),
        (select) => select.getAttribute("data-value")
      );
      this.updateMasterId();
      this.toggleAddButton(true, "", false);
      this.updateVariantStatuses();
      if (!this.currentVariant) {
        this.toggleAddButton(true, "", true);
        this.setUnavailable();
      } else {
        this.updateVariantInput();
        this.renderProductInfo();
      }
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  
    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (input) {
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }
  
    renderProductInfo() {
      if (!this.currentVariant) return;
      let qty = 0;
      let percent = 0;
      let sale = false;
      let availability = window.variantStrings?.inStock;
      let variantStrings = window.variantStrings?.soldOut;
      const compare_at_price = this.currentVariant.compare_at_price;
      const price = this.currentVariant.price;
      const unit_price = this.currentVariant.unit_price;
      const unit_price_measurement = this.currentVariant.unit_price_measurement;
      const form = document.getElementById(
        `product-form-${this.dataset.section}`
      );
      const quickview = form.closest(".bls__product-quickview");
      this.getVariantQtyData().find((variantQty) => {
        if (variantQty.id === this.currentVariant.id) {
          qty = variantQty.qty;
        }
      });
      if (compare_at_price && compare_at_price > price) {
        sale = true;
        percent = ((compare_at_price - price) / compare_at_price) * 100;
      }
      if (this.currentVariant.available && qty < 1) {
        availability = window.variantStrings?.preOrder;
        variantStrings = window.variantStrings?.preOrder;
      } else if (!this.currentVariant.available) {
        availability = window.variantStrings?.outStock;
      } else {
        availability = window.variantStrings?.inStock;
        variantStrings = window.variantStrings?.addToCart;
      }
      if (this.currentVariant.inventory_management === null) {
        availability = window.variantStrings?.inStock;
        variantStrings = window.variantStrings?.addToCart;
      }
      if (quickview.querySelector(".bls__availability-value")) {
        quickview.querySelector(".bls__availability-value").textContent =
          availability;
      }
      const product_label = quickview.querySelector(".bls__product-label");
      if (product_label) {
        product_label.remove();
      }
      if (sale) {
        var element = document.createElement("div");
        element.classList.add(
          "bls__product-label",
          "mb-5",
          "fs-12",
          "pointer-events-none",
          "inline-block",
          "static"
        );
        quickview
          .querySelector(".bls__quickview-content")
          .insertBefore(
            element,
            quickview.querySelector(".bls__quickview-content").children[0]
          );
        const label = quickview.querySelector(".bls__product-label");
        var element_sale = document.createElement("div");
        element_sale.classList.add("bls__sale-label");
        if (window.productLabel.saleType == 'price') {
          element_sale.innerText = "- " + Shopify.formatMoney(
            (compare_at_price - price),
            cartStrings.money_format
          );
        } else if (window.productLabel.saleType == 'text') {
          element_sale.innerText = window.productLabel.saleLabel;
        } else {
          element_sale.innerText = -percent.toFixed(0) + "%";
        }
        if (label) {
          label.appendChild(element_sale);
        }
      }
  
      if (quickview.querySelector(".bls__product-sku-value")) {
        quickview.querySelector(".bls__product-sku-value").textContent =
          this.currentVariant.sku;
      }
  
      const price_format = Shopify.formatMoney(
        this.currentVariant.price,
        cartStrings?.money_format
      );
      if (unit_price && unit_price_measurement) {
        const price_num = Shopify.formatMoney(
          unit_price,
          cartStrings?.money_format
        );
        const price_unit =
          unit_price_measurement.reference_value != 1
            ? unit_price_measurement.reference_value
            : unit_price_measurement.reference_unit;
        const upn = quickview.querySelector(".unit-price .number");
        const upu = quickview.querySelector(".unit-price .unit");
        if (upn) {
          upn.innerHTML = price_num;
        }
        if (upu) {
          upu.innerHTML = price_unit;
        }
      }
      const upp = quickview.querySelector(".price__regular .price");
      if (upp) {
        upp.innerHTML = price_format;
      }
  
      const stockNotify = quickview.querySelector(".product-notify-stock");
      if (stockNotify) {
        if (!this.currentVariant.available) {
          stockNotify.style.display = "block";
          stockNotify.setAttribute(
            "data-product-variant",
            this.currentVariant.id
          );
        } else {
          stockNotify.style.display = "none";
          stockNotify.setAttribute(
            "data-product-variant",
            this.currentVariant.id
          );
        }
      }
  
      const bls__price = quickview.querySelector(".bls__price");
      bls__price.classList.remove("price--sold-out", "price--on-sale");
      bls__price
        .querySelector(".price__regular .price")
        .classList.remove("special-price");
      if (compare_at_price && compare_at_price > price) {
        const compare_format = Shopify.formatMoney(
          compare_at_price,
          cartStrings?.money_format
        );
        if (!bls__price.querySelector(".compare-price")) {
          var ps = bls__price.querySelector(".price__sale");
          var sp = document.createElement("span");
          var cp = document.createElement("s");
          cp.classList.add("price-item", "compare-price");
          sp.appendChild(cp);
          if (ps) {
            ps.appendChild(sp);
          }
        }
        if (bls__price.querySelector(".compare-price")) {
          bls__price.querySelector(".compare-price").innerHTML = compare_format;
        }
        bls__price.classList.add("price--on-sale");
        bls__price
          .querySelector(".price__regular .price")
          .classList.add("special-price");
      } else if (!this.currentVariant.available) {
        bls__price.classList.add("price--sold-out");
      }
      this.toggleAddButton(!this.currentVariant.available, variantStrings);
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(
        `product-form-${this.dataset.section}`
      );
      if (!productForm) return;
      const addButton = productForm.querySelector('.button-add-cart-qv[name="add"]');
      const addButtonText = productForm.querySelector('.button-add-cart-qv[name="add"] > span');
      const buttonPayment = productForm.querySelector('.bls__product-dynamic-checkout');

      if (!addButton) return;
      if (disable) {
        buttonPayment.style.display = 'none';
        addButton.setAttribute("disabled", "disabled");
      } else {
        buttonPayment.style.display = 'block';
        addButton.removeAttribute("disabled");
      }
      if (text) addButtonText.textContent = text;
  
      if (!modifyClass) return;
    }
  
    setUnavailable() {
      const button = document.getElementById(
        `product-form-${this.dataset.section}`
      );
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings?.unavailable;
      if (price) price.classList.add("visibility-hidden");
    }
  
    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    actionDropdownSwatches() {
      this.querySelectorAll("[data-swatches-value]").forEach((items) => {
        items.addEventListener(
          "click",
          (e) => {
            const target = e.currentTarget;
            if (
              !target
                .closest(".bls__color-dropdown")
                .classList.contains("isClicked")
            ) {
              for (var item of this.querySelectorAll(".bls__color-dropdown")) {
                item.classList.remove("isClicked");
              }
              target.closest(".bls__color-dropdown").classList.add("isClicked");
            } else {
              target
                .closest(".bls__color-dropdown")
                .classList.remove("isClicked");
            }
          },
          false
        );
      });
      this.querySelectorAll(".bls__product-color-swatches-dropdown").forEach(
        (swatches) => {
          swatches.addEventListener("click", (e) => {
            const target = e.currentTarget;
            const valueSwatch = target.dataset.value;
            const container = target.closest(".bls__color-dropdown");
            container.querySelector(
              ".bls__color-dropdown-action .bls__color-dropdown-value"
            ).innerHTML = valueSwatch;
            target.closest(".bls__color-dropdown").classList.remove("isClicked");
          });
        }
      );
    }

    setAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
          if (listOfAvailableOptions.includes(input.dataset.value)) {
              input.removeAttribute('data-disabled');
          } else {
              input.setAttribute('data-disabled','disable');
          }
      });
  }
  
    updateVariantStatuses() {
      const selectedOptionOneVariants = this.getVariantData().filter(
        (variant) =>
          this.querySelector(".active").dataset.value === variant.option1
      );
      const inputWrappers = [...this.querySelectorAll(".product-form__input")];
      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll(".bls__option-swatch")];
        const previousOptionSelected =
          inputWrappers[index - 1].querySelector(".active").dataset.value;
        const availableOptionInputsValue = selectedOptionOneVariants
          .filter(
            (variant) =>
              variant.available &&
              variant[`option${index}`] === previousOptionSelected
          )
          .map((variantOption) => variantOption[`option${index + 1}`]);
        this.setAvailability(optionInputs, availableOptionInputsValue);
      });
    }
    
  
    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  
    getVariantQtyData() {
      this.variantQtyData = JSON.parse(
        this.querySelector(".productVariantsQty").textContent
      );
      return this.variantQtyData;
    }
  }
  customElements.define("variant-radios-quickview", VariantRadiosQuickview);

  class CartUpsell extends HTMLElement {
    constructor() {
      super();
    }
    init(){
      this.connectedCallback();
    }
    connectedCallback() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.swiper-wrapper');
          if (recommendations && recommendations.innerHTML.trim().length) {
            if (this.querySelector(".swiper-wrapper")) {
              this.querySelector(".swiper-wrapper").innerHTML = recommendations.innerHTML;
            }
          }
        })
        .finally(() =>{
          BlsSettingsSwiper.init();
          BlsLazyloadImg.init()
          
        })
        .catch(e => {
          console.error(e);
        });
    }
  }
customElements.define('minicart-recommendations', CartUpsell);

class CartUpsellBeside extends HTMLElement {
  constructor() {
    super();
  }
  init(){
    this.connectedCallback();
  }
  connectedCallback() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.swiper-wrapper');
          if (recommendations && recommendations.innerHTML.trim().length) {
            if (this.querySelector(".swiper-wrapper")) {
              this.querySelector(".swiper-wrapper").innerHTML = recommendations.innerHTML;
            }
          }
        const recommendationsBeside = html.querySelector('.bls-cart-upsell-wrapper');
        const beside = document.querySelector('.bls-recommendations-beside');
        if (recommendationsBeside && recommendationsBeside.innerHTML.trim().length && beside) {
          if (this.querySelector('.bls-cart-upsell-wrapper')) {
            this.querySelector('.bls-cart-upsell-wrapper').innerHTML = recommendationsBeside.innerHTML;
          }
        }
      })
      .finally(() =>{
        BlsSettingsSwiper.init();
        BlsLazyloadImg.init()
        
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('minicart-recommendations-beside', CartUpsellBeside);


class CartUpsellHeading extends HTMLElement {
  constructor() {
    super();
    this.querySelector('.button-close-beside').addEventListener('click', (e) => {
      const target = e.currentTarget;
      const closeBeside = target.closest('.bls-recommendations-beside');
      closeBeside.classList.remove('is-opend')
    })
  }
}
customElements.define('minicart-recommendations-heading', CartUpsellHeading);

// Coupon Code Handler for Product Page
(function() {
  'use strict';
  
  // Define functions in global scope so they're accessible
  window.validateCouponCode = async function(code) {
    try {
      if (!code || !code.trim()) {
        return { valid: false, message: 'Please enter a coupon code' };
      }
      
      const couponCode = code.trim().toUpperCase();
      
      // Check code format first
      if (couponCode.length < 3 || couponCode.length > 50) {
        return { valid: false, message: 'Coupon code must be between 3 and 50 characters' };
      }
      
      if (!/^[A-Z0-9_-]+$/.test(couponCode)) {
        return { valid: false, message: 'Invalid coupon code format' };
      }
      
      // Get routes - ensure it's available
      const cartUrl = window.routes?.cart_url || '/cart';
      const cartAddUrl = window.routes?.cart_add_url || '/cart/add.js';
      
      console.log('Validating coupon code:', couponCode);
      
      // Get current cart state
      let cart = null;
      let hadItems = false;
      let tempVariantId = null;
      
      try {
        const cartResponse = await fetch(`${cartUrl}.js`);
        if (cartResponse.ok) {
          cart = await cartResponse.json();
          hadItems = cart.item_count > 0;
        }
      } catch (e) {
        console.log('Could not fetch cart:', e);
      }
      
      // If cart is empty, add a temporary item to validate discount
      if (!hadItems) {
        try {
          // Try to get a product variant ID from the current page
          const productJson = document.querySelector('[data-product-json]');
          let variantId = null;
          
          if (productJson) {
            try {
              const productData = JSON.parse(productJson.textContent);
              if (productData && productData.variants && productData.variants.length > 0) {
                variantId = productData.variants[0].id;
              }
            } catch (e) {
              console.log('Could not parse product JSON');
            }
          }
          
          // If we have a variant, add it temporarily
          if (variantId) {
            tempVariantId = variantId;
            const addResponse = await fetch(cartAddUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                items: [{
                  id: variantId,
                  quantity: 1
                }]
              })
            });
            
            if (!addResponse.ok) {
              console.log('Could not add temp item, will try without it');
              tempVariantId = null;
            } else {
              // Wait a bit for cart to update
              await new Promise(resolve => setTimeout(resolve, 300));
            }
          }
        } catch (e) {
          console.log('Error adding temp item:', e);
        }
      }
      
      // Now try to apply the discount code
      try {
        const formData = new FormData();
        formData.append('discount', couponCode);
        
        const applyResponse = await fetch(`${cartUrl}/discount.json`, {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        
        const responseText = await applyResponse.text();
        console.log('Discount apply response:', applyResponse.status, responseText);
        
        if (applyResponse.ok) {
          // Discount applied successfully - it's valid!
          const isVipCode = couponCode.includes('VIP') || couponCode.startsWith('VIP');
          
          // Remove the discount (we're just validating)
          try {
            await fetch(`${cartUrl}/discount.json`, {
              method: 'DELETE',
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              }
            });
          } catch (e) {
            console.log('Could not remove discount:', e);
          }
          
          // Remove temp item if we added one
          if (tempVariantId && !hadItems) {
            try {
              // Get updated cart to find the item key
              const updatedCartResponse = await fetch(`${cartUrl}.js`);
              if (updatedCartResponse.ok) {
                const updatedCart = await updatedCartResponse.json();
                if (updatedCart.items && updatedCart.items.length > 0) {
                  const itemKey = updatedCart.items[0].key;
                  await fetch(`${cartUrl}/change.js`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({
                      id: itemKey,
                      quantity: 0
                    })
                  });
                }
              }
            } catch (e) {
              console.log('Could not remove temp item:', e);
            }
          }
          
          return { 
            valid: true, 
            message: 'Coupon code is valid',
            isVip: isVipCode
          };
        } else {
          // Discount failed to apply - parse error
          let errorMessage = 'Invalid coupon code';
          
          // Parse error message from response
          try {
            const errorData = JSON.parse(responseText);
            if (errorData.description) {
              errorMessage = errorData.description;
            } else if (errorData.message) {
              errorMessage = errorData.message;
            }
          } catch (e) {
            // Try to extract error from HTML/text response
            if (responseText.includes('not found') || responseText.includes('does not exist') || responseText.includes('invalid')) {
              errorMessage = 'Invalid coupon code';
            } else if (responseText.includes('expired')) {
              errorMessage = 'This coupon code has expired';
            } else if (responseText.includes('already used') || responseText.includes('maximum') || responseText.includes('limit')) {
              errorMessage = 'This coupon code has already been used or reached its limit';
            } else if (responseText.includes('minimum')) {
              errorMessage = 'Coupon code does not meet minimum order requirements';
            } else if (responseText.includes('not applicable') || responseText.includes('cannot be applied')) {
              errorMessage = 'This coupon code cannot be applied to your cart';
            }
          }
          
          // Remove temp item if we added one
          if (tempVariantId && !hadItems) {
            try {
              const updatedCartResponse = await fetch(`${cartUrl}.js`);
              if (updatedCartResponse.ok) {
                const updatedCart = await updatedCartResponse.json();
                if (updatedCart.items && updatedCart.items.length > 0) {
                  const itemKey = updatedCart.items[0].key;
                  await fetch(`${cartUrl}/change.js`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({
                      id: itemKey,
                      quantity: 0
                    })
                  });
                }
              }
            } catch (e) {
              console.log('Could not remove temp item:', e);
            }
          }
          
          return { valid: false, message: errorMessage };
        }
      } catch (fetchError) {
        console.error('Error applying discount:', fetchError);
        
        // Remove temp item if we added one
        if (tempVariantId && !hadItems) {
          try {
            const updatedCartResponse = await fetch(`${cartUrl}.js`);
            if (updatedCartResponse.ok) {
              const updatedCart = await updatedCartResponse.json();
              if (updatedCart.items && updatedCart.items.length > 0) {
                const itemKey = updatedCart.items[0].key;
                await fetch(`${cartUrl}/change.js`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                  },
                  body: JSON.stringify({
                    id: itemKey,
                    quantity: 0
                  })
                });
              }
            }
          } catch (e) {
            console.log('Could not remove temp item:', e);
          }
        }
        
        return { valid: false, message: 'Error validating coupon code. Please try again.' };
      }
      
    } catch (error) {
      console.error('Error validating coupon:', error);
      return { valid: false, message: 'Error validating coupon code. Please try again.' };
    }
  };
  
  window.showCouponMessage = function(messageElement, message, type) {
    if (!messageElement) {
      console.warn('Coupon message element not found');
      return;
    }
    
    messageElement.textContent = message;
    messageElement.style.display = 'block';
    messageElement.className = `coupon-message mt-10 ${type}`;
    
    // For error messages, don't auto-hide
    if (type === 'error') {
      // Keep error visible until user tries again
      return;
    }
    
    // Auto-hide success messages after 5 seconds
    setTimeout(() => {
      if (messageElement && type === 'success') {
        messageElement.style.display = 'none';
      }
    }, 5000);
  };
  
  window.showVipAccessPopup = function() {
    // Create popup HTML
    const popupHTML = `
      <div class="vip-access-popup-content text-center">
        <div class="vip-access-icon mb-20">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="40" cy="40" r="40" fill="#FFD700" opacity="0.2"/>
            <path d="M40 20L45 35L60 36L48 46L52 60L40 52L28 60L32 46L20 36L35 35L40 20Z" fill="#FFD700"/>
          </svg>
        </div>
        <h3 class="vip-access-title mb-15">You have VIP access</h3>
        <p class="vip-access-message mb-20">Congratulations! Your coupon code has been successfully applied. Enjoy exclusive VIP benefits!</p>
        <button class="btn btn-primary vip-popup-close-btn" onclick="closeVipPopup()">Continue Shopping</button>
      </div>
    `;
    
    // Create popup container
    let popupContainer = document.getElementById('vip-access-popup');
    if (!popupContainer) {
      popupContainer = document.createElement('div');
      popupContainer.id = 'vip-access-popup';
      popupContainer.className = 'vip-access-popup-overlay';
      document.body.appendChild(popupContainer);
    }
    
    popupContainer.innerHTML = `
      <div class="vip-access-popup-dialog">
        <button class="vip-popup-close" onclick="closeVipPopup()" aria-label="Close">×</button>
        ${popupHTML}
      </div>
    `;
    
    // Show popup
    popupContainer.classList.add('active');
    document.body.style.overflow = 'hidden';
  };
  
  window.showInvalidCouponPopup = function() {
    // Create popup HTML for invalid coupon
    const popupHTML = `
      <div class="invalid-coupon-popup-content text-center">
        <div class="invalid-coupon-icon mb-20">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="40" cy="40" r="40" fill="#FF3B3B" opacity="0.1"/>
            <path d="M40 25L40 45M40 50L40 55" stroke="#FF3B3B" stroke-width="3" stroke-linecap="round"/>
            <circle cx="40" cy="40" r="30" stroke="#FF3B3B" stroke-width="2" fill="none"/>
          </svg>
        </div>
        <h3 class="invalid-coupon-title mb-15">Invalid Coupon Code</h3>
        <p class="invalid-coupon-message mb-20">The coupon code you entered is invalid. Please verify the code and try again.</p>
        <button class="btn btn-primary invalid-coupon-popup-close-btn" onclick="closeInvalidCouponPopup()">OK</button>
      </div>
    `;
    
    // Create popup container
    let popupContainer = document.getElementById('invalid-coupon-popup');
    if (!popupContainer) {
      popupContainer = document.createElement('div');
      popupContainer.id = 'invalid-coupon-popup';
      popupContainer.className = 'invalid-coupon-popup-overlay';
      document.body.appendChild(popupContainer);
    }
    
    popupContainer.innerHTML = `
      <div class="invalid-coupon-popup-dialog">
        <button class="invalid-coupon-popup-close" onclick="closeInvalidCouponPopup()" aria-label="Close">×</button>
        ${popupHTML}
      </div>
    `;
    
    // Show popup
    popupContainer.classList.add('active');
    document.body.style.overflow = 'hidden';
  };
  
  window.closeVipPopup = function() {
    const popup = document.getElementById('vip-access-popup');
    if (popup) {
      popup.classList.remove('active');
      document.body.style.overflow = '';
    }
  };
  
  window.closeInvalidCouponPopup = function() {
    const popup = document.getElementById('invalid-coupon-popup');
    if (popup) {
      popup.classList.remove('active');
      document.body.style.overflow = '';
    }
  };
  
  // Debounce function for auto-validation
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  function initCouponCode() {
    const couponInputs = document.querySelectorAll('.coupon-code-input');
    
    console.log('Initializing coupon code auto-validation, found inputs:', couponInputs.length);
    
    if (couponInputs.length === 0) {
      // Retry after a short delay if inputs aren't loaded yet
      setTimeout(initCouponCode, 500);
      return;
    }
    
    couponInputs.forEach((input) => {
      // Check if already initialized
      if (input.dataset.initialized === 'true') {
        console.log('Input already initialized, skipping');
        return;
      }
      input.dataset.initialized = 'true';
      
      const sectionId = input.getAttribute('data-section-id');
      console.log('Initializing coupon input for section:', sectionId);
      
      const couponMessage = document.getElementById(`coupon-message-${sectionId}`);
      const appliedIndicator = document.getElementById(`coupon-applied-${sectionId}`);
      const statusIndicator = document.getElementById(`coupon-status-${sectionId}`);
      
      console.log('Found elements:', {
        couponMessage: !!couponMessage,
        appliedIndicator: !!appliedIndicator,
        statusIndicator: !!statusIndicator
      });
      
      // Function to show status indicator
      const showStatus = function(status, message) {
        if (!statusIndicator) {
          console.warn('Status indicator not found for section:', sectionId);
          // Try to find it again
          const retryIndicator = document.getElementById(`coupon-status-${sectionId}`);
          if (!retryIndicator) {
            console.error('Status indicator element does not exist in DOM');
            return;
          }
          statusIndicator = retryIndicator;
        }
        
        console.log('Showing status:', status, 'for code');
        statusIndicator.style.display = 'flex';
        statusIndicator.classList.add('show');
        statusIndicator.className = `coupon-status-indicator coupon-status-${status} show`;
        
        if (status === 'valid') {
          statusIndicator.innerHTML = `
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5" fill="none"/>
              <path d="M5 8L7 10L11 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Valid</span>
          `;
        } else if (status === 'invalid') {
          statusIndicator.innerHTML = `
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5" fill="none"/>
              <path d="M6 6L10 10M10 6L6 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <span>Invalid</span>
          `;
        } else if (status === 'validating') {
          statusIndicator.innerHTML = `
            <span class="coupon-loading">Checking...</span>
          `;
        }
      };
      
      // Function to hide status indicator
      const hideStatus = function() {
        if (statusIndicator) {
          statusIndicator.style.display = 'none';
          statusIndicator.classList.remove('show');
        }
      };
      
      // Auto-validation function
      const validateCoupon = async function(couponCode) {
        console.log('validateCoupon called with:', couponCode);
        
        if (!couponCode || couponCode.trim().length < 3) {
          // Hide indicators if code is too short
          console.log('Code too short, hiding status');
          hideStatus();
          if (appliedIndicator) {
            appliedIndicator.style.display = 'none';
          }
          if (couponMessage) {
            couponMessage.style.display = 'none';
          }
          input.classList.remove('coupon-valid', 'coupon-invalid', 'coupon-validating');
          return;
        }
        
        const code = couponCode.trim().toUpperCase();
        
        // Show validating state
        console.log('Showing validating state for:', code);
        showStatus('validating', 'Checking...');
        input.classList.remove('coupon-valid', 'coupon-invalid');
        input.classList.add('coupon-validating');
        
        try {
          // Validate coupon code with backend
          console.log('Calling validateCouponCode for:', code);
          const validationResult = await window.validateCouponCode(code);
          console.log('Validation result received:', validationResult);
          
          if (validationResult && validationResult.valid) {
            // Store coupon code in localStorage
            localStorage.setItem('discount_code', code);
            localStorage.setItem('coupon_applied', 'true');
            
            // Check if it's a VIP code
            const isVipCode = validationResult.isVip || code.includes('VIP');
            if (isVipCode) {
              localStorage.setItem('vip_access', 'true');
            }
            
            // Show valid status immediately
            console.log('Code is valid, showing valid status');
            showStatus('valid', 'Valid');
            input.classList.remove('coupon-validating', 'coupon-invalid');
            input.classList.add('coupon-valid');
            
            // Show success message
            if (couponMessage) {
              const successMsg = isVipCode 
                ? `VIP code "${code}" applied successfully!` 
                : `Coupon code "${code}" applied successfully`;
              if (window.showCouponMessage) {
                window.showCouponMessage(couponMessage, successMsg, 'success');
              } else {
                couponMessage.textContent = successMsg;
                couponMessage.style.display = 'block';
                couponMessage.className = 'coupon-message mt-10 success';
              }
            }
            
            // After a moment, show applied indicator
            setTimeout(() => {
              hideStatus();
              if (appliedIndicator) {
                appliedIndicator.style.display = 'flex';
                appliedIndicator.innerHTML = `
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Applied
                `;
              }
              
              // Disable input
              input.disabled = true;
              input.classList.add('coupon-applied');
            }, 1500);
            
            // Hide error message if shown
            if (couponMessage) {
              couponMessage.style.display = 'none';
            }
            
            // Show VIP access popup only for VIP codes
            if (isVipCode && window.showVipAccessPopup) {
              setTimeout(() => {
                window.showVipAccessPopup();
              }, 1500);
            }
          } else {
            // Invalid coupon code
            const errorMsg = (validationResult && validationResult.message) || 'Invalid coupon code';
            
            console.log('Coupon validation failed:', errorMsg);
            
            // Show invalid status
            showStatus('invalid', 'Invalid');
            input.classList.remove('coupon-validating', 'coupon-valid');
            input.classList.add('coupon-invalid');
            
            // Hide applied indicator
            if (appliedIndicator) {
              appliedIndicator.style.display = 'none';
            }
            
            // Show error message
            if (couponMessage) {
              if (window.showCouponMessage) {
                window.showCouponMessage(couponMessage, errorMsg, 'error');
              } else {
                couponMessage.textContent = errorMsg;
                couponMessage.style.display = 'block';
                couponMessage.className = 'coupon-message mt-10 error';
              }
            }
            
            // Show invalid coupon popup immediately
            console.log('Attempting to show invalid coupon popup');
            if (typeof window.showInvalidCouponPopup === 'function') {
              setTimeout(() => {
                console.log('Showing invalid coupon popup');
                window.showInvalidCouponPopup();
              }, 500);
            } else {
              console.warn('showInvalidCouponPopup function not found');
              // Fallback: show alert if popup function not available
              setTimeout(() => {
                alert('Invalid coupon code. Please check and try again.');
              }, 500);
            }
            
            // Keep input enabled for retry
            input.disabled = false;
            input.classList.remove('coupon-applied');
          }
        } catch (error) {
          console.error('Error validating coupon code:', error);
          const errorMsg = 'Error validating coupon code. Please try again.';
          
          // Show invalid status
          showStatus('invalid', 'Error');
          input.classList.remove('coupon-validating', 'coupon-valid');
          input.classList.add('coupon-invalid');
          
          // Hide applied indicator
          if (appliedIndicator) {
            appliedIndicator.style.display = 'none';
          }
          
          if (couponMessage) {
            if (window.showCouponMessage) {
              window.showCouponMessage(couponMessage, errorMsg, 'error');
            } else {
              couponMessage.textContent = errorMsg;
              couponMessage.style.display = 'block';
              couponMessage.className = 'coupon-message mt-10 error';
            }
          }
          
          input.disabled = false;
          input.classList.remove('coupon-applied');
        }
      };
      
      // Debounced validation (wait 500ms after user stops typing for faster feedback)
      const debouncedValidate = debounce(validateCoupon, 500);
      
      // Auto-validate on input - with immediate visual feedback
      input.addEventListener('input', function(e) {
        const code = e.target.value.trim();
        console.log('Input event triggered, code:', code);
        
        // Clear previous status immediately
        if (code.length < 3) {
          hideStatus();
          input.classList.remove('coupon-valid', 'coupon-invalid', 'coupon-validating');
          if (couponMessage) {
            couponMessage.style.display = 'none';
          }
          return;
        }
        
        // Show validating state immediately
        console.log('Showing validating state');
        showStatus('validating', 'Checking...');
        input.classList.remove('coupon-valid', 'coupon-invalid');
        input.classList.add('coupon-validating');
        
        // Trigger validation
        debouncedValidate(code);
      });
      
      // Also validate on blur (when user leaves the field)
      input.addEventListener('blur', function(e) {
        const code = e.target.value.trim();
        console.log('Blur event triggered, code:', code);
        if (code.length >= 3) {
          validateCoupon(code);
        }
      });
      
      // Also validate on paste
      input.addEventListener('paste', function(e) {
        setTimeout(() => {
          const code = e.target.value.trim();
          console.log('Paste event triggered, code:', code);
          if (code.length >= 3) {
            showStatus('validating', 'Checking...');
            input.classList.add('coupon-validating');
            validateCoupon(code);
          }
        }, 100);
      });
      
      // Also validate on keyup for Enter key
      input.addEventListener('keyup', function(e) {
        if (e.key === 'Enter') {
          const code = e.target.value.trim();
          if (code.length >= 3) {
            e.preventDefault();
            showStatus('validating', 'Checking...');
            input.classList.add('coupon-validating');
            validateCoupon(code);
          }
        }
      });
      
      // Also validate on blur (when user leaves the field)
      input.addEventListener('blur', function(e) {
        const code = e.target.value.trim();
        if (code.length >= 3) {
          validateCoupon(code);
        }
      });
    });
    
    // Load saved coupon code on page load
    const savedCode = localStorage.getItem('discount_code');
    const isApplied = localStorage.getItem('coupon_applied') === 'true';
    
    if (savedCode && isApplied) {
      couponInputs.forEach(input => {
        if (!input.value) {
          input.value = savedCode;
          const sectionId = input.getAttribute('data-section-id');
          const appliedIndicator = document.getElementById(`coupon-applied-${sectionId}`);
          
          if (appliedIndicator) {
            appliedIndicator.style.display = 'flex';
            appliedIndicator.innerHTML = `
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.5 4.5L6 12L2.5 8.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Applied
            `;
          }
          input.disabled = true;
          input.classList.add('coupon-applied');
        }
      });
    }
  }
  
  // Initialize when DOM is ready - multiple methods to ensure it runs
  function initializeCouponValidation() {
    console.log('Attempting to initialize coupon validation, readyState:', document.readyState);
    initCouponCode();
  }
  
  // Try multiple initialization methods
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCouponValidation);
  } else {
    initializeCouponValidation();
  }
  
  // Also try after a short delay to catch dynamically loaded content
  setTimeout(initializeCouponValidation, 1000);
  setTimeout(initializeCouponValidation, 2000);
  
  // Also listen for Shopify theme events
  if (typeof document.addEventListener !== 'undefined') {
    document.addEventListener('shopify:section:load', initializeCouponValidation);
    document.addEventListener('shopify:section:reorder', initializeCouponValidation);
  }
})();

// Functions are already defined inside IIFE above as window.validateCouponCode, window.showCouponMessage, etc.

// Close popups on overlay click
document.addEventListener('click', function(e) {
  const vipPopup = document.getElementById('vip-access-popup');
  const invalidPopup = document.getElementById('invalid-coupon-popup');
  
  if (vipPopup && e.target === vipPopup && typeof window.closeVipPopup === 'function') {
    window.closeVipPopup();
  }
  
  if (invalidPopup && e.target === invalidPopup && typeof window.closeInvalidCouponPopup === 'function') {
    window.closeInvalidCouponPopup();
  }
});